import { useId } from 'react';

type Props = {
	label: string;
	value: string;
	onChange: (value: string) => void;
	type?: 'text' | 'email';
	placeholder?: string;
	autoComplete?: string;
	/** A message under the field; marks it invalid. */
	error?: string;
	disabled?: boolean;
	/** A multi-line field with this many rows. */
	rows?: number;
	/** The backend's limit for this field. */
	maxLength?: number;
};

/** A labelled field of the site's forms (`.sj-f`), with its own error line. */
export function Field({
	label,
	value,
	onChange,
	type = 'text',
	placeholder,
	autoComplete,
	error,
	disabled,
	rows,
	maxLength,
}: Props) {
	const errorId = useId();
	const shared = {
		value,
		placeholder,
		autoComplete,
		disabled,
		maxLength,
		'aria-invalid': error ? true : undefined,
		'aria-describedby': error ? errorId : undefined,
	};

	return (
		<label className="sj-f">
			<span className="sj-l">{label}</span>
			{rows ? (
				<textarea
					rows={rows}
					{...shared}
					onChange={(e) => onChange(e.currentTarget.value)}
				/>
			) : (
				<input type={type} {...shared} onChange={(e) => onChange(e.currentTarget.value)} />
			)}
			{error && (
				<span className="sj-f-err" id={errorId}>
					{error}
				</span>
			)}
		</label>
	);
}
